<template>
  <div :class="$style['more-subnav-panel']" ref="rootDom">
    <div :class="$style['panel-inner']">
      <div
          v-for="(group, groupIndex) in groups"
          :key="groupIndex"
          :class="$style['column']"
      >
        <div :class="$style['column-title']">{{ group.title }}</div>
        <div :class="$style['nav-list']">
          <a
              v-for="(item, index) in group.items"
              :key="index"
              :class="$style['nav-item']"
              @click="onItemClick(item)"
          >
            <div :class="$style['item-inner']" class="flex items-center">
              <div :class="$style['item-icon']">
                <i v-if="!item.iconType" :class="[$style['ic'], item.icon]"></i>
                <Exicon v-else :size="20" :name="item.icon"/>
              </div>
              <span :class="$style['item-title']">{{ item.title }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {useLighterBorder} from '../../plugins/use-lighter-border'

export default {
  name: 'MoreSubnavPanel',
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cleanupLighterBorder: null,
    }
  },
  mounted() {
    this.cleanupLighterBorder = useLighterBorder(this, this.$refs.rootDom)
  },
  beforeDestroy() {
    if (this.cleanupLighterBorder) {
      this.cleanupLighterBorder()
    }
  },
  methods: {
    onItemClick(item) {
      this.$emit('navigate', item)
    },
  },
}
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/_mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .more-subnav-panel {
    border-color: rgba(0, 0, 0, 0.08);
    background-color: #fff;
    box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.08);

    .column-title {
      color: rgba(0, 0, 0, 0.45);
    }

    .nav-item {
      &:hover {
        background: #f3f4f6;

        .item-title,
        .item-icon {
          color: color(var(--theme-color));
        }
      }

      .item-title {
        color: rgba(0, 0, 0, 0.85);
      }

      .item-icon {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

.more-subnav-panel {
  --border-width: 1px;
  width: max-content;
  padding: 20px 8px 16px;
  transition: var(--transition-theme-color);
  border: var(--border-width) solid rgba(#fff, 0.1);
  border-radius: 12px;
  background: #202020;
  box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.35);

  .panel-inner {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    align-items: flex-start;
    gap: 8px;
  }

  .column {
    min-width: max-content;
    padding: 0 12px;
  }

  .column-title {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    margin-bottom: 8px;
    padding: 0 12px;
    color: color(var(--font-color), 0.45);
  }

  .nav-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nav-item {
    display: block;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: var(--transition-theme-color);

    &:hover {
      background: #282828;

      .item-title,
      .item-icon {
        color: color(var(--theme-color));
      }
    }

    .item-inner {
      gap: 10px;
    }

    .item-icon {
      flex-shrink: 0;
      font-size: 20px;
      line-height: 1;
      color: color(var(--font-color));
      transition: var(--transition-theme-color);
    }

    .item-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      white-space: nowrap;
      color: color(var(--font-color));
      transition: var(--transition-theme-color);
    }
  }
}
</style>
